/**
 * Base utility for making API requests.
 */

const API_BASE_URL = window.__ENV__?.REACT_APP_API_BASE_URL
  || process.env.REACT_APP_API_BASE_URL
  || 'https://90810910-e557-4507-ac52-e099eee844eb--7011.preview.8080.ai';

export function authHeader() {
  const token = typeof window !== 'undefined' ? window.localStorage.getItem('auth_token') : null;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function request(path, options = {}) {
  const url = `${API_BASE_URL}${path}`;
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const errorMessage = errorData.detail || errorData.message || `Error ${response.status}: ${response.statusText}`;

    throw new Error(errorMessage);
  }

  return response.json();
}
